import { render, staticRenderFns } from "./ListLead.vue?vue&type=template&id=ee8bbc88"
import script from "./ListLead.vue?vue&type=script&lang=js"
export * from "./ListLead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports